import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { ACCOUNT_QUERY_KEYS } from '@/lib/constants/account';
import { AccountApi } from '../AccountApi';
import type { IngestcfgCreateReq } from '@/lib/types/Ingest';

export function useCreateUploadProfile() {
  const { selectedCId } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (req: IngestcfgCreateReq) => {
      if (!selectedCId) throw new Error('No account selected');
      return AccountApi.createUploadProfile(selectedCId, req);
    },
    onSuccess: () => {
      if (selectedCId) {
        queryClient.invalidateQueries({ queryKey: ACCOUNT_QUERY_KEYS.uploadProfiles(selectedCId) });
      }
    },
  });
}

export function useUpdateUploadProfile() {
  const { selectedCId } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ ingestcfgId, req }: { ingestcfgId: number; req: IngestcfgCreateReq }) => {
      if (!selectedCId) throw new Error('No account selected');
      return AccountApi.updateUploadProfile(selectedCId, ingestcfgId, req);
    },
    onSuccess: () => {
      if (selectedCId) {
        queryClient.invalidateQueries({ queryKey: ACCOUNT_QUERY_KEYS.uploadProfiles(selectedCId) });
      }
    },
  });
}

export function useDeleteUploadProfiles() {
  const { selectedCId } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (ingestcfgIds: number[]) => {
      if (!selectedCId) throw new Error('No account selected');
      return AccountApi.deleteUploadProfiles(selectedCId, ingestcfgIds);
    },
    onSuccess: () => {
      if (selectedCId) {
        queryClient.invalidateQueries({ queryKey: ACCOUNT_QUERY_KEYS.uploadProfiles(selectedCId) });
      }
    },
  });
}
